import { GetterTree } from 'vuex';
import { IDocumentState } from '@signing-page/documents/store/document.store';
import { IVideo } from '@signing-page/documents/types/video';
import { IRootState } from '@signing-page/store/store';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { SigningHelper } from '@signing-page/signing/helpers/signing.helper';
import { RecipientHelper } from '@signing-page/helpers/recipient.helper';

export const getterViewableRecipients = 'viewableRecipients';
export const getterRecipientsTurnToSign = 'recipientsTurnToSign';
export const getterMyTurnToSign = 'myTurnToSign';
export const getterCurrentRecipient = 'currentRecipient';
export const getterAreAttachmentsUploading = 'areAttachmentsUploading';
export const getterVideoReminder = 'videoReminder';

export const getters: GetterTree<IDocumentState, IRootState> = {
  [getterViewableRecipients](state: IDocumentState, getters, rootState: IRootState): IRecipient[] {
    if (!state.document?.recipients) {
      return [];
    }
    if (rootState.isPreview) {
      return state.document.recipients;
    }

    return RecipientHelper.getViewableRecipients(
      getters[getterCurrentRecipient],
      state.document.recipients
    );
  },
  [getterRecipientsTurnToSign](state: IDocumentState): IRecipient {
    if (!state.document || !state.document.recipients || !state.document.nextRecipientIdToSign) {
      return;
    }
    return state.document.recipients.find(
      (recipient: IRecipient) => recipient.id === state.document.nextRecipientIdToSign
    );
  },
  [getterMyTurnToSign](state: IDocumentState, getters, rootState: IRootState): boolean {
    if (!rootState.recipientId) {
      return false;
    }

    if (!state.document.isSigningOrder) {
      return SigningHelper.isSigningTurnNoSigningOrder(getters.currentRecipient);
    }

    return SigningHelper.isSigningTurnSigningOrder(
      rootState.recipientId,
      state.document.nextRecipientsInLine
    );
  },
  [getterCurrentRecipient](state: IDocumentState, _, rootState: IRootState): IRecipient {
    if (!rootState.recipientId || !state.document || !state.document.recipients) {
      return;
    }
    return state.document.recipients.find(
      (recipient: IRecipient) => recipient.id === rootState.recipientId
    );
  },
  [getterAreAttachmentsUploading](state: IDocumentState): boolean {
    return state.uploadingAttachmentIds?.length > 0;
  },
  [getterVideoReminder](state: IDocumentState, _, rootState: IRootState): IVideo {
    if (!rootState.videoReminderId) {
      return null;
    }
    if (!state.document.documentVideos?.length) {
      return null;
    }
    return state.document.documentVideos.find(
      (documentVideo: IVideo) => documentVideo.id === rootState.videoReminderId
    );
  },
};
